import { render } from "./NotifyWarning.vue?vue&type=template&id=1afe3a33&scoped=true"
import script from "./NotifyWarning.vue?vue&type=script&lang=js"
export * from "./NotifyWarning.vue?vue&type=script&lang=js"

import "./NotifyWarning.vue?vue&type=style&index=0&id=1afe3a33&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afe3a33"]])

export default __exports__